var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconPricing = function SvgIconPricing(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #008060;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3781",
    "data-name": "Group 3781",
    transform: "translate(-253.535 -450.535)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    className: "cls-1",
    width: 24,
    height: 24,
    transform: "translate(253.535 450.535)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "money",
    transform: "translate(258.035 402.847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9412",
    "data-name": "Group 9412",
    transform: "translate(0 52.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4722",
    "data-name": "Path 4722",
    className: "cls-2",
    d: "M246.5,440.178a.295.295,0,1,1,.289-.237A.3.3,0,0,1,246.5,440.178Z",
    transform: "translate(-238.991 -425.712)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4723",
    "data-name": "Path 4723",
    className: "cls-2",
    d: "M13.833,52.438H1.167A1.311,1.311,0,0,0,0,53.853V65.488A1.311,1.311,0,0,0,1.167,66.9H6.176a.362.362,0,0,0,0-.711H1.167a.653.653,0,0,1-.581-.7V57.63a.653.653,0,0,1,.581-.7H13.833a.653.653,0,0,1,.581.7v7.858a.653.653,0,0,1-.581.7H8.824a.362.362,0,0,0,0,.711h5.009A1.311,1.311,0,0,0,15,65.488V53.853A1.311,1.311,0,0,0,13.833,52.438Zm-12.666.711H13.833a.653.653,0,0,1,.581.7V54.5a1.009,1.009,0,0,0-.581-.188H1.167a1.009,1.009,0,0,0-.581.188v-.651a.653.653,0,0,1,.581-.7Zm12.666,3.066H1.167a1.009,1.009,0,0,0-.581.188v-.672a.653.653,0,0,1,.581-.7H13.833a.653.653,0,0,1,.581.7V56.4A1.009,1.009,0,0,0,13.833,56.215Z",
    transform: "translate(0 -52.438)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4724",
    "data-name": "Path 4724",
    className: "cls-2",
    d: "M190.542,245.681a1.989,1.989,0,1,1,1.989-1.989A1.992,1.992,0,0,1,190.542,245.681Zm0-3.389a1.4,1.4,0,1,0,1.4,1.4A1.4,1.4,0,0,0,190.542,242.292Z",
    transform: "translate(-183.042 -233.646)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4725",
    "data-name": "Path 4725",
    className: "cls-2",
    d: "M54.5,209.013H45.906a.294.294,0,0,1-.293-.295,1.328,1.328,0,0,0-1.321-1.332.294.294,0,0,1-.293-.295v-2.434a.294.294,0,0,1,.293-.295,1.328,1.328,0,0,0,1.321-1.332.294.294,0,0,1,.293-.295H54.5a.294.294,0,0,1,.293.295,1.328,1.328,0,0,0,1.321,1.332.294.294,0,0,1,.293.295v2.434a.294.294,0,0,1-.293.295,1.328,1.328,0,0,0-1.321,1.332A.294.294,0,0,1,54.5,209.013Zm-8.322-.59h8.052a1.919,1.919,0,0,1,1.591-1.6v-1.89a1.919,1.919,0,0,1-1.591-1.6H46.176a1.919,1.919,0,0,1-1.591,1.6v1.89A1.919,1.919,0,0,1,46.176,208.424Z",
    transform: "translate(-42.702 -195.845)"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPricing, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-pricing.14ff0139.svg";
export { ForwardRef as ReactComponent };